import { createFileRoute } from '@tanstack/react-router';

import { I18nBreadcrumb } from '@/components/ui/i18breadcrumb';

export const Route = createFileRoute(
  '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/videos'
)({
  staticData: { breadcrumb: () => <I18nBreadcrumb translationKey="videos" /> },
});
